import React from 'react';
import { Container, PrimaryButton, TabsPanel, palette } from '@dev/ee-components';
import { Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { push as Push } from 'redux-first-history';
import { useDispatch, useSelector } from 'react-redux';
import { AccessLevel } from '@dev/ee-api/ee-api-models';

import { AutomationPaths } from '@/services/dictionaries/Paths';
import { getAccountStore } from '@/store/account/actions';
import { getConfigStore } from '@/store/config/actions';
import useMobile from '@/services/hooks/useMobile';

import { sendEventToGTM } from '@dev/ee-tools';
import AutomationReport from './AutomationReport';
import ViewContacts from './AutomationReport/ViewContacts';
import AutomationsList from './AutomationsList';
import AutomationDraftsList from './DraftsList';
import { AutomationsListProps, AutomationTabName, TabNameEnum } from './AutomationsInterface';

const getTabName = (tabIndex: number): TabNameEnum => {
    const tabs = [TabNameEnum.Automations, TabNameEnum.Draft];

    return tabs[tabIndex];
};

const getScreenIndexFromName = (screenName: string): number => {
    if (screenName === AutomationTabName.Drafts) {
        return 1;
    }

    return 0;
};

const getScreenName = (screenIndex: number | string): AutomationTabName => {
    switch (screenIndex) {
        case 1:
        case AutomationTabName.Drafts:
            return AutomationTabName.Drafts;
        default:
            return AutomationTabName.Automations;
    }
};

const Automations = (props: AutomationsListProps): JSX.Element => {
    const {
        match: { params },
    } = props;
    const { t } = useTranslation();
    const { GeneralInfo } = useSelector(getAccountStore);
    const { isStandalone } = useSelector(getConfigStore);
    const accountAl = GeneralInfo?.AccountAccessLevel;
    const dispatch = useDispatch();
    const isMobile = useMobile();

    return (
        <Container>
            <TabsPanel
                tabBackground={isMobile || isStandalone ? '' : palette.basic.paper}
                title={t('automations')}
                isMobile={false}
                value={getScreenIndexFromName(getScreenName(params.tabName))}
                onChange={(__e: any, clickedTabIndex: number): void => {
                    dispatch(Push(AutomationPaths.Automations.replace(':tabName', getTabName(clickedTabIndex))));
                }}
                tabs={[
                    {
                        label: t('automation'),
                    },
                    {
                        label: t('draft'),
                    },
                ]}
                additionalHeaderContent={
                    accountAl?.includes?.(AccessLevel.ModifyAutomations) &&
                    !isMobile && (
                        <PrimaryButton
                            text={t('createautomation')}
                            onClick={(): void => {
                                dispatch(Push(AutomationPaths.AutomationNew));
                                dispatch(sendEventToGTM("start_creating_email_automation"));
                            }}
                        />
                    )
                }
            />
            <Switch>
                <Route exact component={AutomationsList} path={AutomationPaths.Automations.replace(':tabName?', '')} />
                <Route exact component={AutomationsList} path={AutomationPaths.AutomationsList} />
                <Route exact component={AutomationDraftsList} path={AutomationPaths.AutomationsDraftList} />
                <Route exact component={AutomationReport} path={AutomationPaths.AutomationReport} />
                <Route exact component={ViewContacts} path={AutomationPaths.ViewContacts} />
            </Switch>
        </Container>
    );
};

export default Automations;
